export type ShortsOrientation = 'portrait' | 'landscape_letterboxed' | 'square';
export type SubtitleBurnedLang = 'ko' | 'en';

/** BEE-5022 (PRD v1.4): admin select 노출용. DB 는 free string, 운영자가 보는 카탈로그. */
export type ShortsSubtype = 'vod' | 'live' | 'ad';
export type CtaType = 'internal' | 'external' | 'none';
/** BEE-5022 (PRD v1.4 LIVE flow): cta_channel_id 가 어느 서비스 채널인지 식별. */
export type LiveService = 'odk' | 'amasian';

export interface ShortsMetaInterface {
  id?: number;
  content?: number;
  subtype?: string | null;
  commerce_flag?: boolean;
  live_flag?: boolean;
  ai_generated_flag?: boolean;
  human_reviewed_flag?: boolean;
  orientation?: ShortsOrientation | null;
  start_offset_ms?: number | null;
  end_offset_ms?: number | null;
  subtitle_burned_lang?: SubtitleBurnedLang | null;
  // BEE-5022 (PRD v1.4 #19/#22/#40)
  internal_title?: string;
  shorts_description?: string | null;
  /** BEE-5028: i18n description dict ({ko, en, 'zh-hans', ...}). shorts_description 은 default lang fallback. */
  i18n_shorts_description?: import('../../../../shared/types/i18n/i18nTypes').I18nFieldData | null;
  cta_type?: CtaType | string;
  start_timestamp?: number | null;
  cta_url?: string | null;
  impression_tracking_url?: string | null;
  cta_channel_id?: number | null;
  /** BEE-5022: subtype='live' & cta_type='internal' 일 때 cta_channel_id 가 어느 서비스 채널인지. */
  live_service?: LiveService | string | null;
  /** Read-only — backend serializer 가 season/series.logo 에서 채움. */
  parent_program_logo?: string | null;
  created?: string;
  modified?: string;
}

export const ORIENTATION_OPTIONS: { value: ShortsOrientation; label: string }[] = [
  { value: 'portrait', label: 'Portrait (9:16)' },
  { value: 'landscape_letterboxed', label: 'Landscape Letterboxed (16:9)' },
  { value: 'square', label: 'Square (1:1)' },
];

export const SUBTITLE_BURNED_LANG_OPTIONS: { value: SubtitleBurnedLang; label: string }[] = [
  { value: 'ko', label: 'Korean (KO)' },
  { value: 'en', label: 'English (EN)' },
];

export const SUBTYPE_OPTIONS: { value: ShortsSubtype; label: string }[] = [
  { value: 'vod', label: 'VOD clip (episode 일부)' },
  { value: 'live', label: 'Live (channel deeplink)' },
  { value: 'ad', label: 'Ad creative' },
];

export const CTA_TYPE_OPTIONS: { value: CtaType; label: string }[] = [
  { value: 'internal', label: 'Internal (앱 내 deeplink)' },
  { value: 'external', label: 'External (URL outlink)' },
  { value: 'none', label: 'None' },
];

export const LIVE_SERVICE_OPTIONS: { value: LiveService; label: string }[] = [
  { value: 'odk', label: 'ODK' },
  { value: 'amasian', label: 'Amasian' },
];
